module.exports = __webpack_public_path__ + "assets/check-toggle-white.46a3dcf5.svg";